enum TargetType {
  All = 0,
  Beast = 1 << 0,
  Demon = 1 << 1,
  Dragonkin = 1 << 2,
  Elemental = 1 << 3,
  Giant = 1 << 4,
  Humanoid = 1 << 5,
  Mechanical = 1 << 6,
  Undead = 1 << 7
}

export default TargetType
